import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type InvoiceHubEvents = 'EXPORT_RESULT';

export const invoiceHub: Record<InvoiceHubEvents, MixpanelEvent> = {
  EXPORT_RESULT: {
    eventDescription: 'Export Invoice Result',
    eventKey: 'export-invoice-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  }
};
